import { render, staticRenderFns } from "./Template-01.vue?vue&type=template&id=01c580bc&scoped=true&"
import script from "./Template-01.vue?vue&type=script&lang=js&"
export * from "./Template-01.vue?vue&type=script&lang=js&"
import style0 from "./Template-01.vue?vue&type=style&index=0&id=01c580bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c580bc",
  null
  
)

export default component.exports